import { Helmet } from "react-helmet-async";
import { mediaUrl } from "@/lib/api";
import { useSite } from "@/context/SiteContext";

export default function SEO({ title, description, image, type = "website", article, canonical }) {
  const { settings } = useSite();
  const siteName = settings.site_name || "Sunset Magazine RD";
  const fullTitle = title ? `${title} — ${siteName}` : `${siteName} — Editorial Digital Premium`;
  const desc = description || settings.description || "Revista digital premium de cultura, viajes, gastronomía y estilo de vida.";
  const img = image ? mediaUrl(image) : "";
  const url = canonical || (typeof window !== "undefined" ? window.location.href : "");

  const jsonLd = article
    ? {
        "@context": "https://schema.org",
        "@type": "Article",
        headline: article.title,
        description: desc,
        image: img ? [img] : [],
        datePublished: article.published_at,
        dateModified: article.updated_at || article.published_at,
        author: article.author ? { "@type": "Person", name: article.author.name } : undefined,
        publisher: { "@type": "Organization", name: siteName },
        mainEntityOfPage: url,
        articleSection: article.category?.name,
      }
    : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {url && <link rel="canonical" href={url} />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={title || siteName} />
      <meta property="og:description" content={desc} />
      {img && <meta property="og:image" content={img} />}
      {url && <meta property="og:url" content={url} />}

      <meta name="twitter:card" content={img ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={title || siteName} />
      <meta name="twitter:description" content={desc} />
      {img && <meta name="twitter:image" content={img} />}

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
